const toCamelCase = (str: string | undefined) => {
  if (!str) return str
  return str.replace(/(^|\s+)(\w)/g, (_, space: string, char: string) =>
    space ? char.toUpperCase() : char.toLowerCase()
  )
}
export default toCamelCase
